import React from "react";
import { useNavigate } from "react-router-dom";

// Premium Plus Maritime Palette - High Contrast & Tech-Focused
const colors = {
  brand: "#1E293B",      // Deep Navy Slate
  maritime: "#03f8d7",   // Signature Electric Teal
  glass: "rgba(255, 255, 255, 0.03)", 
  textMain: "#0F172A",
  textMuted: "#64748b",
  white: "#ffffff",
  border: "rgba(226, 232, 240, 0.8)"
};

function PublicNavbar() {
  const navigate = useNavigate();

  // Extract active tenant identifier from storage or URL parameters
  const tenantId = localStorage.getItem("adminId") || "global";
  const activeTenantName = "MARITIME SUPPLY";

  return (
    <nav className="navbar-premium" data-tenant-scope={tenantId}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800;900&display=swap');

        .navbar-premium {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 5%;
          height: 85px;
          background: rgba(255, 255, 255, 0.85);
          border-bottom: 1px solid ${colors.border};
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 10000;
          backdrop-filter: blur(15px) saturate(180%);
          font-family: 'Inter', sans-serif;
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.03);
        }

        /* --- LOGO ENGINE --- */
        .logo-group {
          display: flex;
          align-items: center;
          gap: 14px;
          cursor: pointer;
          transition: transform 0.2s ease;
        }

        .logo-group:hover { transform: scale(1.02); }

        .logo-hexagon {
          width: 42px;
          height: 42px;
          background: ${colors.brand};
          color: ${colors.maritime};
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          box-shadow: 0 8px 16px rgba(30, 41, 59, 0.2);
        }

        .logo-hexagon::after {
          content: '';
          position: absolute;
          inset: -2px;
          border-radius: 14px;
          background: linear-gradient(45deg, ${colors.maritime}, transparent);
          z-index: -1;
          opacity: 0.5;
        }

        .text-stack {
          display: flex;
          flex-direction: column;
          line-height: 1;
        }

        .main-brand {
          font-size: 20px;
          font-weight: 900;
          color: ${colors.brand};
          letter-spacing: -0.5px;
          text-transform: uppercase;
        }

        .sub-brand {
          font-size: 9px;
          font-weight: 800;
          color: ${colors.maritime};
          letter-spacing: 1.5px;
          margin-top: 2px;
        }

        /* --- NAVIGATION ACTIONS --- */
        .nav-actions {
          display: flex;
          align-items: center;
          gap: 35px;
        }

        .nav-item {
          font-size: 12px;
          font-weight: 700;
          color: ${colors.brand};
          text-transform: uppercase;
          letter-spacing: 0.8px;
          cursor: pointer;
          position: relative;
          transition: color 0.3s ease;
        }

        .nav-item::after {
          content: '';
          position: absolute;
          bottom: -6px;
          left: 0;
          width: 0%;
          height: 2px;
          background: ${colors.maritime};
          transition: width 0.3s ease;
        }

        .nav-item:hover { color: ${colors.maritime}; }
        .nav-item:hover::after { width: 100%; }

        /* --- PREMIUM REGISTRATION BOX --- */
        .reg-box {
          position: relative;
          padding: 2px;
          background: linear-gradient(135deg, ${colors.brand}, #475569);
          border-radius: 10px;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          box-shadow: 0 10px 20px rgba(30, 41, 59, 0.15);
        }

        .reg-box:hover {
          transform: translateY(-2px);
          box-shadow: 0 15px 30px rgba(3, 248, 215, 0.2);
        }

        .reg-btn {
          background: ${colors.brand};
          color: ${colors.white};
          border: 1px solid rgba(255,255,255,0.1);
          padding: 12px 24px;
          border-radius: 8px;
          font-size: 11px;
          font-weight: 900;
          letter-spacing: 1px;
          cursor: pointer;
          text-transform: uppercase;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .reg-btn span {
          color: ${colors.maritime};
          font-size: 14px;
        }

        /* --- MOBILE ADAPTIVE ENGINE --- */
        @media (max-width: 900px) {
          .nav-actions { gap: 20px; }
          .nav-item.hide-mobile { display: none; }
        }

        @media (max-width: 600px) {
          .navbar-premium { height: 75px; padding: 0 4%; }
          .main-brand { font-size: 16px; }
          .sub-brand { font-size: 7px; }
          .reg-btn { padding: 10px 16px; font-size: 10px; }
          .reg-btn span { display: none; }
        }
      `}</style>

      {/* LOGO UNIT */}
      <div className="logo-group" onClick={() => navigate("/")}>
        <div className="logo-hexagon">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        </div>
        <div className="text-stack">
          <span className="main-brand">{activeTenantName}</span>
          <span className="sub-brand">OPERATIONAL SUITE</span>
        </div>
      </div>

      {/* ACTION UNIT */}
      <div className="nav-actions">
        <span className="nav-item hide-mobile" onClick={() => navigate("/")}>Overview</span>
        <span className="nav-item" onClick={() => navigate("/login")}>Login</span>

        <div className="reg-box">
          <button className="reg-btn" onClick={() => navigate("/signup")}>
            <span>+</span> Register Now
          </button>
        </div>
      </div>
    </nav>
  );
}

export default PublicNavbar;